import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TabComponent from './../batch-assignment/tab-component';
import OnlinePlans from './online-plans';
import { ALL_TABS } from 'constants/pricing-management';
import memoize from 'memoize-one';
import styled from 'styled-components';

const Container = styled.div`
  width: inherit;
  height: inherit;
  margin: 0 auto;
`;

const { ONLINE_PLANS } = ALL_TABS || {};

const TABS = [
  {
    id: ONLINE_PLANS,
    label: ONLINE_PLANS,
    Component: OnlinePlans,
  },
];

const getTabs = memoize(tabs =>
  tabs.map(tab => ({
    ...tab,
    link: `/pricing-management/${tab.id}`,
  })),
);

class PricingManagement extends PureComponent {
  static defaultProps = {
    match: null,
  };

  static propTypes = {
    match: PropTypes.shape({}),
  };

  render() {
    const {
      match: {
        params: { activeTab },
      },
    } = this.props;
    const tabs = getTabs(TABS);

    return (
      <Container>
        <TabComponent tabs={tabs} activeTab={activeTab} />
      </Container>
    );
  }
}

export default PricingManagement;
